import { useEffect, useRef, useState } from "react"
import { Appear } from "@components/motion/Appear"
import { cn } from "@utils/tw"
import { AdminMessage } from "./AdminMessage"

export const HubspotForm = ({
  portalId = "47489066",
  formId,
  region = "na1",
  raw = false,
  className,
  onReady = () => {},
  onSuccess = () => {},
}: {
  portalId?: string
  formId: string
  region?: string
  raw?: boolean
  className?: string
  onReady?: () => void
  onSuccess?: () => void
}) => {
  const formRef = useRef<HTMLDivElement>(null)
  const [formActive, setFormActive] = useState(false)
  const formReady = useRef(false)

  useEffect(() => {
    if (env.admin) return

    if (formRef.current && !formActive && !formReady.current) {
      const script = document.createElement("script")
      script.src = "//js.hsforms.net/forms/embed/v2.js"
      script.type = "text/javascript"
      script.charset = "utf-8"
      script.onload = () => {
        if (formActive || formReady.current) return
        // @ts-ignore
        if (window.hbspt) {
          // @ts-ignore
          const form = window.hbspt.forms.create({
            portalId: portalId,
            formId: formId,
            region: region,
            onBeforeFormInit: (ctx: any) => {
              // console.log("Form is about to be initialized", ctx)
            },
            onFormSubmitted: () => {
              onSuccess()
            },
            onFormReady: () => {
              onReady()
            },
          })
          const el = document.getElementById(`hbspt-form-${form.instanceId}`)!
          formRef.current?.appendChild(el)
          formReady.current = true

          if (!raw) {
            // monitor when iframe is added to el element
            const observer = new MutationObserver((mutations) => {
              mutations.forEach((mutation) => {
                mutation.addedNodes.forEach((node) => {
                  if ((node as HTMLElement).tagName === "IFRAME") {
                    setFormActive(true)
                    observer.disconnect()
                  }
                })
              })
            })
            observer.observe(el, { childList: true })
          } else {
            setFormActive(true)
          }
        } else {
          setFormActive(true)
        }
      }
      document.body.appendChild(script)
    }
  }, [portalId, formId, region, formActive, raw, onReady, onSuccess])

  return (
    <>
      <Appear active={formActive} className={cn("w-full", className)}>
        <div ref={formRef} />
      </Appear>
      <AdminMessage>Form {formId} will appear here in the live site</AdminMessage>
    </>
  )
}
